import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UseFormReturn } from 'react-hook-form';

import { TextFieldElement } from 'components/muiInputWrappers';
import { useTranslation } from 'react-i18next';

export type FormFields = {
  productSerialNumber?: number;
};

type Props = {
  form: UseFormReturn;
};

function ConfigComponentSearch({ form }: Props) {
  const { t } = useTranslation('global');

  return (
    <Box>
      <Typography>{t('common.commonProperties.serialn')}:</Typography>
      <TextFieldElement
        control={form?.control}
        name="productSerialNumber"
        placeholder={`${t('common.commonProperties.serialn')}:`}
        size="small"
        style={{ width: '100%' }}
        type="text"
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 30,
            message: t('ticket.messages.valueLongerThan30')
          }
        }}
        variant="outlined"
      />
    </Box>
  );
}

export default ConfigComponentSearch;
